// ============================================================
// CATÁLOGO MK ELETROMÓVEIS — ARQUIVO ÚNICO DE DADOS
// Para alterar preço, foto, nome ou remover/adicionar produto,
// edite somente este arquivo.
// ============================================================

export const LOJAS = [
  {
    id: 'doutor-ulysses',
    nome: 'Loja Doutor Ulysses',
    cidade: 'Doutor Ulysses - PR',
    telefone: '+55 41 99748-7959',
    numero: '5541997487959',
  },
  {
    id: 'cerro-azul',
    nome: 'Loja Cerro Azul',
    cidade: 'Cerro Azul - PR',
    telefone: '+55 41 99717-5979',
    numero: '5541997175979',
  },
];

export const CATEGORIAS = [
  { id: 'todos', nome: 'Todos' },
  { id: 'geladeiras', nome: 'Geladeiras' },
  { id: 'freezers', nome: 'Freezers' },
  { id: 'fogoes', nome: 'Fogões' },
  { id: 'centrifugas', nome: 'Centrífugas' },
  { id: 'smart-tvs', nome: 'Smart TVs' },
  { id: 'microondas', nome: 'Microondas' },
  { id: 'fornos', nome: 'Fornos' },
  { id: 'fritadeiras', nome: 'Fritadeiras' },
  { id: 'batedeiras', nome: 'Batedeiras' },
  { id: 'liquidificadores', nome: 'Liquidificadores' },
  { id: 'utensilios', nome: 'Utensílios' },
  { id: 'ferros', nome: 'Ferros de Passar' },
  { id: 'maquinas', nome: 'Máquinas de Corte' },
  { id: 'hair', nome: 'Linha Hair' },
  { id: 'chaleiras', nome: 'Chaleiras e Cafeteiras' },
];

export const PRODUTOS = [
  // ---------------- GELADEIRAS ----------------
  {
    id: 'geladeira-consul-333-1',
    nome: 'Geladeira Consul 333L Frost Free',
    marca: 'Consul',
    categoria: 'geladeiras',
    imagem: '/produtos/geladeira-1.png',
    preco: 3050.0,
    parcelas: { vezes: 12, valor: 299.9 },
    detalhes: ['Capacidade: 333 litros', 'Frost Free', 'Marca: Consul'],
    descricao: 'Geladeira Consul Frost Free de 333 litros: prática e econômica, não precisa descongelar.',
  },
  {
    id: 'geladeira-consul-333-2',
    nome: 'Geladeira Consul 333L Frost Free',
    marca: 'Consul',
    categoria: 'geladeiras',
    imagem: '/produtos/geladeira-2.png',
    preco: 3499.0,
    parcelas: { vezes: 12, valor: 333.25 },
    detalhes: ['Capacidade: 333 litros', 'Frost Free', 'Marca: Consul'],
    descricao: 'Geladeira Consul Frost Free de 333 litros. Consulte as cores disponíveis pelo WhatsApp.',
  },
  {
    id: 'geladeira-midea-394',
    nome: 'Geladeira Midea 394L Frost Free Inox',
    marca: 'Midea',
    categoria: 'geladeiras',
    imagem: '/produtos/geladeira-3.png',
    preco: 3199.0,
    parcelas: { vezes: 12, valor: 333.25 },
    detalhes: ['Capacidade: 394 litros', 'Frost Free', 'Acabamento Inox', 'Marca: Midea'],
    descricao: 'Geladeira Midea Frost Free de 394 litros com acabamento em inox.',
  },
  {
    id: 'geladeira-electrolux-432-1',
    nome: 'Geladeira Electrolux 432L Frost Free Inox',
    marca: 'Electrolux',
    categoria: 'geladeiras',
    imagem: '/produtos/geladeira-4.png',
    preco: 4400.0,
    parcelas: { vezes: 12, valor: 408.25 },
    detalhes: ['Capacidade: 432 litros', 'Frost Free', 'Acabamento Inox', 'Marca: Electrolux'],
    descricao: 'Geladeira Electrolux Frost Free de 432 litros com acabamento em inox.',
  },
  {
    id: 'geladeira-electrolux-432-2',
    nome: 'Geladeira Electrolux 432L Frost Free Inox',
    marca: 'Electrolux',
    categoria: 'geladeiras',
    imagem: '/produtos/geladeira-5.png',
    preco: 4699.0,
    parcelas: { vezes: 12, valor: 432.5 },
    detalhes: ['Capacidade: 432 litros', 'Frost Free', 'Acabamento Inox', 'Marca: Electrolux'],
    descricao: 'Geladeira Electrolux Frost Free de 432 litros com acabamento em inox.',
  },
  // ---------------- FREEZERS ----------------
  {
    id: 'freezer-philco-143',
    nome: 'Freezer Philco 143L Horizontal',
    marca: 'Philco',
    categoria: 'freezers',
    imagem: '/produtos/freezer-1.png',
    preco: 1899.0,
    parcelas: { vezes: 10, valor: 209.99 },
    detalhes: ['Capacidade: 143 litros', 'Modelo: Horizontal', 'Marca: Philco'],
    descricao: 'Freezer horizontal Philco de 143 litros, ideal para o dia a dia.',
  },
  {
    id: 'freezer-philco-199',
    nome: 'Freezer Philco 199L Horizontal',
    marca: 'Philco',
    categoria: 'freezers',
    imagem: '/produtos/freezer-2.png',
    preco: 2350.0,
    parcelas: { vezes: 10, valor: 259.9 },
    detalhes: ['Capacidade: 199 litros', 'Modelo: Horizontal', 'Marca: Philco'],
    descricao: 'Freezer horizontal Philco de 199 litros com ótimo espaço interno.',
  },
  {
    id: 'freezer-philco-253',
    nome: 'Freezer Philco 253L Horizontal',
    marca: 'Philco',
    categoria: 'freezers',
    imagem: '/produtos/freezer-3.png',
    preco: 2399.0,
    parcelas: { vezes: 12, valor: 224.9 },
    detalhes: ['Capacidade: 253 litros', 'Modelo: Horizontal', 'Marca: Philco'],
    descricao: 'Freezer horizontal Philco de 253 litros para quem precisa de mais espaço.',
  },
  {
    id: 'freezer-philco-299',
    nome: 'Freezer Philco 299L Horizontal',
    marca: 'Philco',
    categoria: 'freezers',
    imagem: '/produtos/freezer-4.png',
    preco: 2599.0,
    parcelas: { vezes: 12, valor: 241.5 },
    detalhes: ['Capacidade: 299 litros', 'Modelo: Horizontal', 'Marca: Philco'],
    descricao: 'Freezer horizontal Philco de 299 litros, o maior da linha.',
  },
  // ---------------- FOGÕES ----------------
  {
    id: 'fogao-atlas-4b',
    nome: 'Fogão Atlas 4 Bocas Automático',
    marca: 'Atlas',
    categoria: 'fogoes',
    imagem: '/produtos/fogao-1.png',
    preco: 1050.0,
    parcelas: { vezes: 12, valor: 98.0 },
    detalhes: ['4 bocas', 'Acendimento automático', 'Disponível em duas cores', 'Marca: Atlas'],
    descricao: 'Fogão Atlas de 4 bocas com acendimento automático. Disponível em duas cores.',
  },
  {
    id: 'fogao-realce-4b',
    nome: 'Fogão Realce 4 Bocas',
    marca: 'Realce',
    categoria: 'fogoes',
    imagem: '/produtos/fogao-2.png',
    preco: 899.0,
    parcelas: { vezes: 10, valor: 99.9 },
    detalhes: ['4 bocas', 'Disponível em duas cores', 'Marca: Realce'],
    descricao: 'Fogão Realce de 4 bocas. Disponível em duas cores.',
  },
  {
    id: 'fogao-mueller-4b',
    nome: 'Fogão Mueller 4 Bocas Automático',
    marca: 'Mueller',
    categoria: 'fogoes',
    imagem: '/produtos/fogao-3.png',
    preco: 1099.0,
    parcelas: { vezes: 10, valor: 104.1 },
    detalhes: ['4 bocas', 'Acendimento automático', 'Disponível em duas cores', 'Marca: Mueller'],
    descricao: 'Fogão Mueller de 4 bocas com acendimento automático. Disponível em duas cores.',
  },
  {
    id: 'fogao-braslar-4b',
    nome: 'Fogão Braslar 4 Bocas',
    marca: 'Braslar',
    categoria: 'fogoes',
    imagem: '/produtos/fogao-4.png',
    preco: 770.0,
    parcelas: { vezes: 10, valor: 88.9 },
    detalhes: ['4 bocas', 'Disponível em duas cores', 'Marca: Braslar'],
    descricao: 'Fogão Braslar de 4 bocas. Disponível em duas cores.',
  },
  {
    id: 'fogao-atlas-5b',
    nome: 'Fogão Atlas 5 Bocas Automático',
    marca: 'Atlas',
    categoria: 'fogoes',
    imagem: '/produtos/fogao-5.png',
    preco: 1450.0,
    parcelas: { vezes: 12, valor: 133.25 },
    detalhes: ['5 bocas', 'Acendimento automático', 'Disponível em duas cores', 'Marca: Atlas'],
    descricao: 'Fogão Atlas de 5 bocas com acendimento automático. Disponível em duas cores.',
  },
  {
    id: 'fogao-atlas-topglass-5b',
    nome: 'Fogão Atlas Top Glass 5 Bocas Mesa de Vidro',
    marca: 'Atlas',
    categoria: 'fogoes',
    imagem: '/produtos/fogao-6.png',
    preco: 1699.0,
    parcelas: { vezes: 12, valor: 166.6 },
    detalhes: ['5 bocas', 'Acendimento automático', 'Mesa de vidro Top Glass', 'Marca: Atlas'],
    descricao: 'Fogão Atlas Top Glass de 5 bocas com mesa de vidro e acendimento automático.',
  },
  {
    id: 'fogao-mueller-5b',
    nome: 'Fogão Mueller 5 Bocas Automático',
    marca: 'Mueller',
    categoria: 'fogoes',
    imagem: '/produtos/fogao-7.png',
    preco: 1439.9,
    parcelas: { vezes: 12, valor: 133.25 },
    detalhes: ['5 bocas', 'Acendimento automático', 'Disponível em duas cores', 'Marca: Mueller'],
    descricao: 'Fogão Mueller de 5 bocas com acendimento automático. Disponível em duas cores.',
  },
  // ---------------- CENTRÍFUGAS ----------------
  {
    id: 'centrifuga-britania-15-plastico',
    nome: 'Centrífuga Britânia 15kg Cesto de Plástico',
    marca: 'Britânia',
    categoria: 'centrifugas',
    imagem: '/produtos/centrifuga-1.png',
    preco: 699.0,
    parcelas: { vezes: 10, valor: 79.9 },
    detalhes: ['Capacidade: 15kg', 'Cesto de plástico', 'Marca: Britânia'],
    descricao: 'Centrífuga de roupas Britânia com capacidade de 15kg e cesto de plástico.',
  },
  {
    id: 'centrifuga-britania-15-inox',
    nome: 'Centrífuga Britânia 15kg Cesto Inox',
    marca: 'Britânia',
    categoria: 'centrifugas',
    imagem: '/produtos/centrifuga-2.png',
    preco: 799.0,
    parcelas: { vezes: 10, valor: 89.9 },
    detalhes: ['Capacidade: 15kg', 'Cesto inox', 'Marca: Britânia'],
    descricao: 'Centrífuga de roupas Britânia com capacidade de 15kg e cesto em inox.',
  },
  {
    id: 'centrifuga-mueller-15-plastico',
    nome: 'Centrífuga Mueller 15kg Cesto de Plástico',
    marca: 'Mueller',
    categoria: 'centrifugas',
    imagem: '/produtos/centrifuga-3.png',
    preco: 749.0,
    parcelas: { vezes: 10, valor: 85.0 },
    detalhes: ['Capacidade: 15kg', 'Cesto de plástico', 'Marca: Mueller'],
    descricao: 'Centrífuga de roupas Mueller com capacidade de 15kg e cesto de plástico.',
  },
  // ---------------- SMART TVS ----------------
  {
    id: 'smart-tv-32-philco',
    nome: 'Smart TV 32" Philco',
    marca: 'Philco',
    categoria: 'smart-tvs',
    imagem: '/produtos/tv-1.png',
    preco: 1399.0,
    parcelas: { vezes: 12, valor: 133.25 },
    detalhes: ['Tela: 32 polegadas', 'Smart TV', 'Marca: Philco'],
    descricao: 'Smart TV Philco de 32 polegadas.',
  },
  {
    id: 'smart-tv-32-aoc',
    nome: 'Smart TV 32" AOC',
    marca: 'AOC',
    categoria: 'smart-tvs',
    imagem: '/produtos/tv-2.png',
    preco: 1399.0,
    parcelas: { vezes: 12, valor: 133.0 },
    detalhes: ['Tela: 32 polegadas', 'Smart TV Roku TV', 'Marca: AOC'],
    descricao: 'Smart TV AOC de 32 polegadas com sistema Roku TV.',
  },
  {
    id: 'smart-tv-40-philco',
    nome: 'Smart TV 40" Philco',
    marca: 'Philco',
    categoria: 'smart-tvs',
    imagem: '/produtos/tv-3.png',
    preco: 1999.0,
    parcelas: { vezes: 12, valor: 186.5 },
    detalhes: ['Tela: 40 polegadas', 'Smart TV Roku TV', 'Marca: Philco'],
    descricao: 'Smart TV Philco de 40 polegadas com sistema Roku TV.',
  },
  {
    id: 'smart-tv-40-aoc',
    nome: 'Smart TV 40" AOC',
    marca: 'AOC',
    categoria: 'smart-tvs',
    imagem: '/produtos/tv-4.png',
    preco: 1999.0,
    parcelas: { vezes: 12, valor: 174.9 },
    detalhes: ['Tela: 40 polegadas', 'Smart TV Roku TV', 'Marca: AOC'],
    descricao: 'Smart TV AOC de 40 polegadas com sistema Roku TV.',
  },
  {
    id: 'smart-tv-50-philco',
    nome: 'Smart TV 50" Philco',
    marca: 'Philco',
    categoria: 'smart-tvs',
    imagem: '/produtos/tv-5.png',
    preco: 2499.0,
    parcelas: { vezes: 12, valor: 240.0 },
    detalhes: ['Tela: 50 polegadas', 'Smart TV Android TV', 'Marca: Philco'],
    descricao: 'Smart TV Philco de 50 polegadas com sistema Android TV.',
  },
  // ---------------- MICROONDAS ----------------
  {
    id: 'microondas-philco-20',
    nome: 'Microondas Philco 20L',
    marca: 'Philco',
    categoria: 'microondas',
    imagem: '/produtos/microondas-1.png',
    preco: 710.0,
    parcelas: { vezes: 10, valor: 75.0 },
    detalhes: ['Capacidade: 20 litros', 'Marca: Philco'],
    descricao: 'Microondas Philco de 20 litros.',
  },
  {
    id: 'microondas-philco-28-espelhado',
    nome: 'Microondas Philco 28L Espelhado',
    marca: 'Philco',
    categoria: 'microondas',
    imagem: '/produtos/microondas-2.png',
    preco: 845.0,
    parcelas: { vezes: 10, valor: 88.9 },
    detalhes: ['Capacidade: 28 litros', 'Porta espelhada', 'Marca: Philco'],
    descricao: 'Microondas Philco de 28 litros com porta espelhada.',
  },
  {
    id: 'microondas-consul-32',
    nome: 'Microondas Consul 32L',
    marca: 'Consul',
    categoria: 'microondas',
    imagem: '/produtos/microondas-3.png',
    preco: 799.0,
    parcelas: { vezes: 10, valor: 85.0 },
    detalhes: ['Capacidade: 32 litros', 'Marca: Consul'],
    descricao: 'Microondas Consul de 32 litros.',
  },
  {
    id: 'microondas-consul-32-espelhado',
    nome: 'Microondas Consul 32L Espelhado',
    marca: 'Consul',
    categoria: 'microondas',
    imagem: '/produtos/microondas-4.png',
    preco: 855.0,
    parcelas: { vezes: 10, valor: 89.9 },
    detalhes: ['Capacidade: 32 litros', 'Porta espelhada', 'Marca: Consul'],
    descricao: 'Microondas Consul de 32 litros com porta espelhada.',
  },
  // ---------------- FORNOS ----------------
  {
    id: 'forno-mueller-50',
    nome: 'Forno Mueller 50L',
    marca: 'Mueller',
    categoria: 'fornos',
    imagem: '/produtos/forno-1.png',
    preco: 835.0,
    parcelas: { vezes: 10, valor: 88.0 },
    detalhes: ['Capacidade: 50 litros', 'Disponível em duas cores', 'Marca: Mueller'],
    descricao: 'Forno elétrico Mueller de 50 litros. Disponível em duas cores.',
  },
  {
    id: 'forno-philco-50',
    nome: 'Forno Philco 50L',
    marca: 'Philco',
    categoria: 'fornos',
    imagem: '/produtos/forno-2.png',
    preco: 699.9,
    parcelas: { vezes: 10, valor: 73.0 },
    detalhes: ['Capacidade: 50 litros', 'Marca: Philco'],
    descricao: 'Forno elétrico Philco de 50 litros.',
  },
  {
    id: 'forno-britania-52',
    nome: 'Forno Britânia 52L',
    marca: 'Britânia',
    categoria: 'fornos',
    imagem: '/produtos/forno-3.png',
    preco: 750.0,
    parcelas: { vezes: 10, valor: 78.9 },
    detalhes: ['Capacidade: 52 litros', 'Marca: Britânia'],
    descricao: 'Forno elétrico Britânia de 52 litros.',
  },
  {
    id: 'forno-philco-49',
    nome: 'Forno Philco 49L',
    marca: 'Philco',
    categoria: 'fornos',
    imagem: '/produtos/forno-4.png',
    preco: 615.0,
    parcelas: { vezes: 10, valor: 65.0 },
    detalhes: ['Capacidade: 49 litros', 'Marca: Philco'],
    descricao: 'Forno elétrico Philco de 49 litros.',
  },
  // ---------------- FRITADEIRAS ----------------
  {
    id: 'fritadeira-britania-11',
    nome: 'Fritadeira Elétrica Britânia 11L',
    marca: 'Britânia',
    categoria: 'fritadeiras',
    imagem: '/produtos/fritadeira-1.png',
    preco: 569.9,
    parcelas: { vezes: 10, valor: 59.99 },
    detalhes: ['Capacidade: 11 litros', 'Marca: Britânia'],
    descricao: 'Fritadeira elétrica Britânia de 11 litros.',
  },
  {
    id: 'fritadeira-britania-42',
    nome: 'Fritadeira Elétrica Britânia 4,2L',
    marca: 'Britânia',
    categoria: 'fritadeiras',
    imagem: '/produtos/fritadeira-2.png',
    preco: 379.0,
    parcelas: { vezes: 10, valor: 39.9 },
    detalhes: ['Capacidade: 4,2 litros', 'Marca: Britânia'],
    descricao: 'Fritadeira elétrica Britânia de 4,2 litros.',
  },
  {
    id: 'fritadeira-wap-4',
    nome: 'Fritadeira Elétrica WAP 4L',
    marca: 'WAP',
    categoria: 'fritadeiras',
    imagem: '/produtos/fritadeira-3.png',
    preco: 379.0,
    parcelas: { vezes: 10, valor: 39.9 },
    detalhes: ['Capacidade: 4 litros', 'Marca: WAP'],
    descricao: 'Fritadeira elétrica WAP de 4 litros.',
  },
  {
    id: 'fritadeira-philco-4',
    nome: 'Fritadeira Elétrica Philco 4L',
    marca: 'Philco',
    categoria: 'fritadeiras',
    imagem: '/produtos/fritadeira-4.png',
    preco: 399.9,
    parcelas: { vezes: 10, valor: 41.99 },
    detalhes: ['Capacidade: 4 litros', 'Marca: Philco'],
    descricao: 'Fritadeira elétrica Philco de 4 litros.',
  },
  // ---------------- BATEDEIRAS ----------------
  {
    id: 'batedeira-mondial-400',
    nome: 'Batedeira Mondial 400W',
    marca: 'Mondial',
    categoria: 'batedeiras',
    imagem: '/produtos/batedeira-1.png',
    preco: 210.0,
    parcelas: { vezes: 10, valor: 22.5 },
    detalhes: ['Potência: 400W', 'Marca: Mondial'],
    descricao: 'Batedeira Mondial com potência de 400W.',
  },
  {
    id: 'batedeira-britania-perola-550',
    nome: 'Batedeira Britânia Pérola 550 500W Turbo 2 Tigelas',
    marca: 'Britânia',
    categoria: 'batedeiras',
    imagem: '/produtos/batedeira-2.png',
    preco: 195.0,
    parcelas: { vezes: 5, valor: 41.0 },
    detalhes: ['Potência: 500W Turbo', '2 tigelas (Double Bowl)', 'Marca: Britânia'],
    descricao: 'Batedeira Britânia Pérola 550 com 500W de potência turbo e 2 tigelas.',
  },
  {
    id: 'batedeira-britania-planetaria-700',
    nome: 'Batedeira Britânia Planetária Turbo Power Plus 700W',
    marca: 'Britânia',
    categoria: 'batedeiras',
    imagem: '/produtos/batedeira-3.png',
    preco: 465.0,
    parcelas: { vezes: 10, valor: 48.99 },
    detalhes: ['Potência: 700W', 'Planetária Turbo Power Plus', 'Marca: Britânia'],
    descricao: 'Batedeira planetária Britânia Turbo Power Plus com 700W de potência.',
  },
  {
    id: 'batedeira-philco-planetaria-700',
    nome: 'Batedeira Philco Planetária 700W Turbo 3 Batedores',
    marca: 'Philco',
    categoria: 'batedeiras',
    imagem: '/produtos/batedeira-4.png',
    preco: 465.0,
    parcelas: { vezes: 10, valor: 48.99 },
    detalhes: ['Potência: 700W Turbo', 'Planetária com 3 batedores', 'Marca: Philco'],
    descricao: 'Batedeira planetária Philco com 700W de potência turbo e 3 batedores.',
  },
  {
    id: 'batedeira-britania-planetaria-900',
    nome: 'Batedeira Britânia Planetária 900W Turbo 3 Batedores',
    marca: 'Britânia',
    categoria: 'batedeiras',
    imagem: '/produtos/batedeira-5.png',
    preco: 485.0,
    parcelas: { vezes: 10, valor: 50.99 },
    detalhes: ['Potência: 900W Turbo', 'Planetária com 3 batedores', 'Marca: Britânia'],
    descricao: 'Batedeira planetária Britânia com 900W de potência turbo e 3 batedores.',
  },
  // ---------------- LIQUIDIFICADORES ----------------
  {
    id: 'liquidificador-philco-1200-inox',
    nome: 'Liquidificador Philco 1200W Inox 3L',
    marca: 'Philco',
    categoria: 'liquidificadores',
    imagem: '/produtos/liquidificador-1.png',
    preco: 245.0,
    parcelas: { vezes: 5, valor: 51.98 },
    detalhes: ['Potência: 1200W', 'Capacidade: 3 litros', 'Inox', 'Jarra de acrílico'],
    descricao: 'Liquidificador Philco 1200W inox com jarra de acrílico de 3 litros.',
  },
  {
    id: 'liquidificador-britania-900',
    nome: 'Liquidificador Britânia 900W Turbo 2,6L',
    marca: 'Britânia',
    categoria: 'liquidificadores',
    imagem: '/produtos/liquidificador-2.png',
    preco: 205.0,
    parcelas: { vezes: 5, valor: 43.0 },
    detalhes: ['Potência: 900W Turbo', 'Capacidade: 2,6 litros', 'Jarra de acrílico'],
    descricao: 'Liquidificador Britânia 900W turbo com jarra de acrílico de 2,6 litros.',
  },
  {
    id: 'liquidificador-britania-1100',
    nome: 'Liquidificador Britânia 1100W Turbo 2,6L',
    marca: 'Britânia',
    categoria: 'liquidificadores',
    imagem: '/produtos/liquidificador-3.png',
    preco: 179.0,
    parcelas: { vezes: 5, valor: 37.98 },
    detalhes: ['Potência: 1100W Turbo', 'Capacidade: 2,6 litros', 'Jarra de acrílico', 'Disponível em duas cores'],
    descricao: 'Liquidificador Britânia 1100W turbo com jarra de acrílico de 2,6 litros. Disponível em duas cores.',
  },
  {
    id: 'liquidificador-mondial-550',
    nome: 'Liquidificador Mondial 550W Turbo Power 2,2L',
    marca: 'Mondial',
    categoria: 'liquidificadores',
    imagem: '/produtos/liquidificador-4.png',
    preco: 155.0,
    parcelas: { vezes: 5, valor: 33.0 },
    detalhes: ['Potência: 550W Turbo Power', 'Capacidade: 2,2 litros', 'Jarra de acrílico', 'Disponível em duas cores'],
    descricao: 'Liquidificador Mondial 550W Turbo Power com jarra de acrílico de 2,2 litros. Disponível em duas cores.',
  },
  {
    id: 'liquidificador-britania-1050',
    nome: 'Liquidificador Britânia 1050W Turbo 2,6L',
    marca: 'Britânia',
    categoria: 'liquidificadores',
    imagem: '/produtos/liquidificador-5.png',
    preco: 215.0,
    parcelas: { vezes: 5, valor: 45.6 },
    detalhes: ['Potência: 1050W Turbo', 'Capacidade: 2,6 litros', 'Jarra de acrílico'],
    descricao: 'Liquidificador Britânia 1050W turbo com jarra de acrílico de 2,6 litros.',
  },
  {
    id: 'liquidificador-britania-1300-fortis',
    nome: 'Liquidificador Britânia 1300W Fortis Turbo 3L',
    marca: 'Britânia',
    categoria: 'liquidificadores',
    imagem: '/produtos/liquidificador-8.png',
    preco: 255.0,
    parcelas: { vezes: 5, valor: 53.98 },
    detalhes: ['Potência: 1300W Fortis Turbo', 'Capacidade: 3 litros', 'Jarra de acrílico'],
    descricao: 'Liquidificador Britânia 1300W Fortis Turbo com jarra de acrílico de 3 litros.',
  },
  {
    id: 'liquidificador-philco-1050',
    nome: 'Liquidificador Philco 1050W 2,2L',
    marca: 'Philco',
    categoria: 'liquidificadores',
    imagem: '/produtos/liquidificador-9.png',
    preco: 215.0,
    parcelas: { vezes: 5, valor: 45.98 },
    detalhes: ['Potência: 1050W', 'Capacidade: 2,2 litros', 'Jarra de acrílico'],
    descricao: 'Liquidificador Philco 1050W com jarra de acrílico de 2,2 litros.',
  },
  // ---------------- UTENSÍLIOS DE COZINHA ----------------
  {
    id: 'processador-gubi-500',
    nome: 'Processador de Alimentos Gubi 500ml',
    marca: 'Gubi',
    categoria: 'utensilios',
    imagem: '/produtos/utensilio-1.png',
    preco: 17.0,
    parcelas: null,
    detalhes: ['Capacidade: 500ml', 'Marca: Gubi'],
    descricao: 'Processador de alimentos Gubi com capacidade de 500ml.',
  },
  {
    id: 'mixer-elite-imports',
    nome: 'Mixer Elite Imports',
    marca: 'Elite Imports',
    categoria: 'utensilios',
    imagem: '/produtos/utensilio-2.png',
    preco: 115.0,
    parcelas: null,
    detalhes: ['Marca: Elite Imports'],
    descricao: 'Mixer Elite Imports.',
  },
  {
    id: 'espremedor-mondial',
    nome: 'Espremedor de Frutas Mondial',
    marca: 'Mondial',
    categoria: 'utensilios',
    imagem: '/produtos/utensilio-3.png',
    preco: 189.9,
    parcelas: { vezes: 5, valor: 39.98 },
    detalhes: ['Marca: Mondial'],
    descricao: 'Espremedor de frutas Mondial.',
  },
  {
    id: 'processador-elite-imports-500',
    nome: 'Processador de Alimentos Elite Imports 500ml',
    marca: 'Elite Imports',
    categoria: 'utensilios',
    imagem: '/produtos/utensilio-4.png',
    preco: 189.9,
    parcelas: { vezes: 5, valor: 39.98 },
    detalhes: ['Capacidade: 500ml', 'Marca: Elite Imports'],
    descricao: 'Processador de alimentos Elite Imports com capacidade de 500ml.',
  },
  {
    id: 'multiprocessador-philco-turbo-5em1',
    nome: 'Multiprocessador Philco Turbo 5 em 1 1000W',
    marca: 'Philco',
    categoria: 'utensilios',
    imagem: '/produtos/utensilio-5.png',
    preco: 399.9,
    parcelas: { vezes: 10, valor: 42.5 },
    detalhes: ['Potência: 1000W', '5 funções em 1', 'Marca: Philco'],
    descricao: 'Multiprocessador Philco Turbo 5 em 1 com 1000W de potência.',
  },
  {
    id: 'kit-utensilios-silicone-12',
    nome: 'Kit 12 Peças Utensílios de Cozinha em Silicone',
    marca: null,
    categoria: 'utensilios',
    imagem: '/produtos/utensilio-6.png',
    preco: 69.9,
    parcelas: null,
    detalhes: ['12 peças', 'Utensílios em silicone'],
    descricao: 'Kit com 12 peças de utensílios de cozinha em silicone.',
  },
  {
    id: 'fogareiro-gas-elite-imports',
    nome: 'Fogareiro a Gás Elite Imports',
    marca: 'Elite Imports',
    categoria: 'utensilios',
    imagem: '/produtos/utensilio-7.png',
    preco: 139.9,
    parcelas: { vezes: 5, valor: 29.98 },
    detalhes: ['A gás', 'Marca: Elite Imports'],
    descricao: 'Fogareiro a gás Elite Imports.',
  },
  {
    id: 'acendedor-carvao-multi',
    nome: 'Acendedor de Carvão Multi',
    marca: 'Multi',
    categoria: 'utensilios',
    imagem: '/produtos/utensilio-8.png',
    preco: 169.9,
    parcelas: { vezes: 5, valor: 35.8 },
    detalhes: ['Marca: Multi'],
    descricao: 'Acendedor de carvão Multi.',
  },
  // ---------------- FERROS DE PASSAR ----------------
  {
    id: 'ferro-elgin-easy-pass',
    nome: 'Ferro de Passar Elgin Easy Pass 1200W',
    marca: 'Elgin',
    categoria: 'ferros',
    imagem: '/produtos/ferro-1.png',
    preco: 129.0,
    parcelas: { vezes: 3, valor: 46.33 },
    detalhes: ['Potência: 1200W', 'Modelo: Easy Pass', 'Marca: Elgin'],
    descricao: 'Ferro de passar Elgin Easy Pass com 1200W de potência.',
  },
  {
    id: 'ferro-black-decker-classic',
    nome: 'Ferro de Passar Black+Decker The Classic',
    marca: 'Black+Decker',
    categoria: 'ferros',
    imagem: '/produtos/ferro-2.png',
    preco: 169.0,
    parcelas: { vezes: 5, valor: 35.8 },
    detalhes: ['Modelo: The Classic', 'Marca: Black+Decker'],
    descricao: 'Ferro de passar Black+Decker The Classic.',
  },
  {
    id: 'ferro-britania-super-carbon',
    nome: 'Ferro de Passar Britânia Super Carbon',
    marca: 'Britânia',
    categoria: 'ferros',
    imagem: '/produtos/ferro-3.png',
    preco: 115.0,
    parcelas: { vezes: 3, valor: 41.66 },
    detalhes: ['Modelo: Super Carbon', 'Marca: Britânia'],
    descricao: 'Ferro de passar Britânia Super Carbon.',
  },
  {
    id: 'ferro-britania-super-carbon-1250',
    nome: 'Ferro de Passar Britânia Super Carbon 1250W',
    marca: 'Britânia',
    categoria: 'ferros',
    imagem: '/produtos/ferro-4.png',
    preco: 99.9,
    parcelas: { vezes: 3, valor: 35.0 },
    detalhes: ['Potência: 1250W', 'Modelo: Super Carbon', 'Marca: Britânia'],
    descricao: 'Ferro de passar Britânia Super Carbon com 1250W de potência.',
  },
  {
    id: 'ferro-philco-1200',
    nome: 'Ferro de Passar Philco 1200W',
    marca: 'Philco',
    categoria: 'ferros',
    imagem: '/produtos/ferro-5.png',
    preco: 159.0,
    parcelas: { vezes: 5, valor: 33.98 },
    detalhes: ['Potência: 1200W', 'Marca: Philco'],
    descricao: 'Ferro de passar Philco com 1200W de potência.',
  },
  {
    id: 'ferro-philco-ceramic-extreme',
    nome: 'Ferro de Passar Philco Ceramic Extreme',
    marca: 'Philco',
    categoria: 'ferros',
    imagem: '/produtos/ferro-6.png',
    preco: 199.0,
    parcelas: { vezes: 5, valor: 41.98 },
    detalhes: ['Modelo: Ceramic Extreme', 'Marca: Philco'],
    descricao: 'Ferro de passar Philco Ceramic Extreme.',
  },
  // ---------------- MÁQUINAS DE CORTE ----------------
  {
    id: 'maquininha-dragao-hair-trimmer',
    nome: 'Maquininha Dragão Hair Trimmer',
    marca: 'Dragão',
    categoria: 'maquinas',
    imagem: '/produtos/maquininha-1.png',
    preco: 45.0,
    parcelas: null,
    detalhes: ['Modelo: Hair Trimmer', 'Marca: Dragão'],
    descricao: 'Maquininha de corte Dragão Hair Trimmer.',
  },
  {
    id: 'maquininha-dragao-holda',
    nome: 'Maquininha Dragão Holda',
    marca: 'Dragão',
    categoria: 'maquinas',
    imagem: '/produtos/maquininha-2.png',
    preco: 49.9,
    parcelas: null,
    detalhes: ['Modelo: Holda', 'Marca: Dragão'],
    descricao: 'Maquininha de corte Dragão Holda.',
  },
  {
    id: 'aparador-pelos-inova',
    nome: 'Aparador de Pelos Inova',
    marca: 'Inova',
    categoria: 'maquinas',
    imagem: '/produtos/maquininha-3.png',
    preco: 59.9,
    parcelas: null,
    detalhes: ['Marca: Inova'],
    descricao: 'Aparador de pelos Inova.',
  },
  {
    id: 'barbeador-usb-kemei',
    nome: 'Barbeador USB Kemei',
    marca: 'Kemei',
    categoria: 'maquinas',
    imagem: '/produtos/maquininha-4.png',
    preco: 125.0,
    parcelas: null,
    detalhes: ['Carregamento USB', 'Marca: Kemei'],
    descricao: 'Barbeador USB Kemei.',
  },
  {
    id: 'maquininha-eletrica-kemei-135',
    nome: 'Maquininha Elétrica Kemei',
    marca: 'Kemei',
    categoria: 'maquinas',
    imagem: '/produtos/maquininha-5.png',
    preco: 135.0,
    parcelas: null,
    detalhes: ['Marca: Kemei'],
    descricao: 'Maquininha elétrica Kemei.',
  },
  {
    id: 'maquininha-eletrica-kemei-99',
    nome: 'Maquininha Elétrica Kemei',
    marca: 'Kemei',
    categoria: 'maquinas',
    imagem: '/produtos/maquininha-6.png',
    preco: 99.0,
    parcelas: null,
    detalhes: ['Marca: Kemei'],
    descricao: 'Maquininha elétrica Kemei.',
  },
  {
    id: 'cortador-4em1-multi-care',
    nome: 'Cortador 4 em 1 Multi Care',
    marca: 'Multi Care',
    categoria: 'maquinas',
    imagem: '/produtos/maquininha-7.png',
    preco: 115.0,
    parcelas: null,
    detalhes: ['4 funções em 1', 'Marca: Multi Care'],
    descricao: 'Cortador 4 em 1 Multi Care.',
  },
  {
    id: 'maquininha-britania-18w',
    nome: 'Maquininha Britânia 18W',
    marca: 'Britânia',
    categoria: 'maquinas',
    imagem: '/produtos/maquininha-8.png',
    preco: 89.9,
    parcelas: null,
    detalhes: ['Potência: 18W', 'Marca: Britânia'],
    descricao: 'Maquininha de corte Britânia 18W.',
  },
  {
    id: 'maquininha-philco-18w',
    nome: 'Maquininha Philco 18W',
    marca: 'Philco',
    categoria: 'maquinas',
    imagem: '/produtos/maquininha-9.png',
    preco: 89.9,
    parcelas: null,
    detalhes: ['Potência: 18W', 'Marca: Philco'],
    descricao: 'Maquininha de corte Philco 18W.',
  },
  {
    id: 'maquininha-kemei-189',
    nome: 'Maquininha Kemei',
    marca: 'Kemei',
    categoria: 'maquinas',
    imagem: '/produtos/maquininha-10.png',
    preco: 189.9,
    parcelas: null,
    detalhes: ['Marca: Kemei'],
    descricao: 'Maquininha de corte Kemei.',
  },
  {
    id: 'barbeador-aparador-kemei',
    nome: 'Barbeador / Aparador Kemei',
    marca: 'Kemei',
    categoria: 'maquinas',
    imagem: '/produtos/maquininha-11.png',
    preco: 95.0,
    parcelas: null,
    detalhes: ['Barbeador e aparador', 'Marca: Kemei'],
    descricao: 'Barbeador e aparador Kemei.',
  },
  // ---------------- LINHA HAIR ----------------
  {
    id: 'secador-gama-eleganza-plus',
    nome: 'Secador GAMA Eleganza Plus 2100W',
    marca: 'GAMA',
    categoria: 'hair',
    imagem: '/produtos/hair-1.png',
    preco: 215.0,
    parcelas: { vezes: 5, valor: 45.8 },
    detalhes: ['Potência: 2100W', 'Modelo: Eleganza Plus', 'Marca: GAMA'],
    descricao: 'Secador de cabelo GAMA Eleganza Plus com 2100W de potência.',
  },
  {
    id: 'secador-philco-tourmaline-2200',
    nome: 'Secador Philco Íon Tourmaline 2200W',
    marca: 'Philco',
    categoria: 'hair',
    imagem: '/produtos/hair-2.png',
    preco: 189.9,
    parcelas: { vezes: 5, valor: 39.98 },
    detalhes: ['Potência: 2200W', 'Íon Tourmaline', 'Disponível em duas cores', 'Marca: Philco'],
    descricao: 'Secador Philco Íon Tourmaline 2200W. Disponível em duas cores.',
  },
  {
    id: 'secador-philco-tourmaline-2100',
    nome: 'Secador Philco Íon Tourmaline 2100W',
    marca: 'Philco',
    categoria: 'hair',
    imagem: '/produtos/hair-3.png',
    preco: 189.9,
    parcelas: { vezes: 5, valor: 39.98 },
    detalhes: ['Potência: 2100W', 'Íon Tourmaline', 'Marca: Philco'],
    descricao: 'Secador Philco Íon Tourmaline 2100W.',
  },
  {
    id: 'secador-britania-2000',
    nome: 'Secador Britânia 2000W',
    marca: 'Britânia',
    categoria: 'hair',
    imagem: '/produtos/hair-4.png',
    preco: 179.9,
    parcelas: { vezes: 5, valor: 37.98 },
    detalhes: ['Potência: 2000W', 'Marca: Britânia'],
    descricao: 'Secador de cabelo Britânia com 2000W de potência.',
  },
  {
    id: 'chapinha-britania-titanium-blue',
    nome: 'Chapinha Britânia Titanium Blue Bivolt',
    marca: 'Britânia',
    categoria: 'hair',
    imagem: '/produtos/hair-6.png',
    preco: 189.9,
    parcelas: { vezes: 5, valor: 39.98 },
    detalhes: ['Modelo: Titanium Blue', 'Bivolt', 'Marca: Britânia'],
    descricao: 'Chapinha Britânia Titanium Blue bivolt.',
  },
  {
    id: 'chapinha-philco-ceramic-black',
    nome: 'Chapinha Philco Ceramic Black Bivolt',
    marca: 'Philco',
    categoria: 'hair',
    imagem: '/produtos/hair-7.png',
    preco: 139.9,
    parcelas: { vezes: 5, valor: 29.98 },
    detalhes: ['Modelo: Ceramic Black', 'Bivolt', 'Marca: Philco'],
    descricao: 'Chapinha Philco Ceramic Black bivolt.',
  },
  {
    id: 'escova-rotativa-britania-1300',
    nome: 'Escova Secadora Rotativa Britânia 1300W',
    marca: 'Britânia',
    categoria: 'hair',
    imagem: '/produtos/hair-8.png',
    preco: 215.0,
    parcelas: { vezes: 5, valor: 45.98 },
    detalhes: ['Potência: 1300W', 'Rotativa', 'Marca: Britânia'],
    descricao: 'Escova secadora rotativa Britânia com 1300W de potência.',
  },
  {
    id: 'escova-britania-1300-159',
    nome: 'Escova Secadora Britânia 1300W',
    marca: 'Britânia',
    categoria: 'hair',
    imagem: '/produtos/hair-9.png',
    preco: 159.9,
    parcelas: { vezes: 5, valor: 33.98 },
    detalhes: ['Potência: 1300W', 'Marca: Britânia'],
    descricao: 'Escova secadora Britânia com 1300W de potência.',
  },
  {
    id: 'escova-britania-vih-tube',
    nome: 'Escova Secadora Britânia 1300W VIH Tube',
    marca: 'Britânia',
    categoria: 'hair',
    imagem: '/produtos/hair-10.png',
    preco: 235.0,
    parcelas: { vezes: 5, valor: 49.98 },
    detalhes: ['Potência: 1300W', 'Modelo: VIH Tube', 'Marca: Britânia'],
    descricao: 'Escova secadora Britânia 1300W modelo VIH Tube.',
  },
  {
    id: 'escova-britania-1300-compacta',
    nome: 'Escova Secadora Britânia 1300W Compacta',
    marca: 'Britânia',
    categoria: 'hair',
    imagem: '/produtos/hair-11.png',
    preco: 189.9,
    parcelas: { vezes: 5, valor: 39.98 },
    detalhes: ['Potência: 1300W', 'Modelo: Compacta', 'Marca: Britânia'],
    descricao: 'Escova secadora Britânia 1300W modelo compacto.',
  },
  {
    id: 'escova-britania-1300-189',
    nome: 'Escova Secadora Britânia 1300W',
    marca: 'Britânia',
    categoria: 'hair',
    imagem: '/produtos/hair-12.png',
    preco: 189.9,
    parcelas: { vezes: 5, valor: 39.98 },
    detalhes: ['Potência: 1300W', 'Disponível em duas cores', 'Marca: Britânia'],
    descricao: 'Escova secadora Britânia 1300W. Disponível em duas cores.',
  },
  {
    id: 'escova-philco',
    nome: 'Escova Secadora Philco',
    marca: 'Philco',
    categoria: 'hair',
    imagem: '/produtos/hair-13.png',
    preco: 159.9,
    parcelas: { vezes: 5, valor: 33.98 },
    detalhes: ['Marca: Philco'],
    descricao: 'Escova secadora Philco.',
  },
  // ---------------- CHALEIRAS E CAFETEIRAS ----------------
  {
    id: 'chaleira-polak-inox-2l',
    nome: 'Chaleira Polak 2L Inox',
    marca: 'Polak',
    categoria: 'chaleiras',
    imagem: '/produtos/chaleira-1.png',
    preco: 39.9,
    precoDe: 65.0,
    parcelas: null,
    detalhes: ['Capacidade: 2 litros', 'Inox', 'Marca: Polak'],
    descricao: 'Chaleira Polak inox de 2 litros.',
  },
  {
    id: 'chaleira-polak-vidro-2l',
    nome: 'Chaleira Polak de Vidro 2L',
    marca: 'Polak',
    categoria: 'chaleiras',
    imagem: '/produtos/chaleira-2.png',
    preco: 99.9,
    parcelas: null,
    detalhes: ['Capacidade: 2 litros', 'Jarra de vidro', 'Marca: Polak'],
    descricao: 'Chaleira Polak de vidro com capacidade de 2 litros.',
  },
  {
    id: 'chaleira-polak-colorida-26',
    nome: 'Chaleira Polak Colorida 2,6L',
    marca: 'Polak',
    categoria: 'chaleiras',
    imagem: '/produtos/chaleira-3.png',
    preco: 99.9,
    parcelas: { vezes: 3, valor: 36.0 },
    detalhes: ['Capacidade: 2,6 litros', 'Cores variadas', 'Marca: Polak'],
    descricao: 'Chaleira Polak colorida de 2,6 litros.',
  },
  {
    id: 'chaleira-britania-inox-12',
    nome: 'Chaleira Britânia 1,2L Inox',
    marca: 'Britânia',
    categoria: 'chaleiras',
    imagem: '/produtos/chaleira-4.png',
    preco: 119.0,
    parcelas: { vezes: 3, valor: 43.3 },
    detalhes: ['Capacidade: 1,2 litros', 'Inox', 'Marca: Britânia'],
    descricao: 'Chaleira Britânia inox de 1,2 litros.',
  },
  {
    id: 'cafeteira-oster-19',
    nome: 'Cafeteira Oster 19 Xícaras',
    marca: 'Oster',
    categoria: 'chaleiras',
    imagem: '/produtos/chaleira-5.png',
    preco: 185.0,
    parcelas: { vezes: 5, valor: 39.98 },
    detalhes: ['Capacidade: 19 xícaras', 'Marca: Oster'],
    descricao: 'Cafeteira Oster com capacidade para 19 xícaras.',
  },
  {
    id: 'cafeteira-elgin-30',
    nome: 'Cafeteira Elgin 30 Xícaras',
    marca: 'Elgin',
    categoria: 'chaleiras',
    imagem: '/produtos/chaleira-6.png',
    preco: 199.0,
    parcelas: { vezes: 5, valor: 43.0 },
    detalhes: ['Capacidade: 30 xícaras', 'Marca: Elgin'],
    descricao: 'Cafeteira Elgin com capacidade para 30 xícaras.',
  },
  {
    id: 'cafeteira-britania-30',
    nome: 'Cafeteira Britânia 30 Xícaras',
    marca: 'Britânia',
    categoria: 'chaleiras',
    imagem: '/produtos/chaleira-7.png',
    preco: 245.0,
    parcelas: { vezes: 6, valor: 43.3 },
    detalhes: ['Capacidade: 30 xícaras', 'Marca: Britânia'],
    descricao: 'Cafeteira Britânia com capacidade para 30 xícaras.',
  },
];

export const formatarPreco = (valor) =>
  valor.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });

// O selo "OFERTA" aparece automaticamente quando o produto tem preço promocional (de/por).
export const emOferta = (produto) => produto.precoDe != null;

export async function copiarTexto(texto) {
  try {
    await navigator.clipboard.writeText(texto);
    return true;
  } catch {
    try {
      const area = document.createElement('textarea');
      area.value = texto;
      area.style.position = 'fixed';
      area.style.opacity = '0';
      document.body.appendChild(area);
      area.select();
      document.execCommand('copy');
      area.remove();
      return true;
    } catch {
      return false;
    }
  }
}

export function linkWhatsApp(loja, produto) {
  const mensagem = produto
    ? `Olá! Vi o produto ${produto.nome} no catálogo digital da MK Eletromóveis, pelo preço de ${formatarPreco(produto.preco)}. Gostaria de mais informações e de consultar as condições de pagamento.`
    : 'Olá! Vim pelo catálogo digital da MK Eletromóveis e gostaria de mais informações sobre os produtos.';
  return `https://wa.me/${loja.numero}?text=${encodeURIComponent(mensagem)}`;
}
